import * as React from "react";
import { useEffect, useState } from "react";
import DeleteIcon from "@mui/icons-material/Delete";
import DownloadIcon from "@mui/icons-material/Download";
import PictureAsPdfIcon from "@mui/icons-material/PictureAsPdf";
import OpenInNewIcon from "@mui/icons-material/OpenInNew";
import {
    Box,
    Button,
    Grid,
    IconButton,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    TextField,
    Typography,
} from "@mui/material";
import { apiRequest } from "../../../api/ApiCall";
import { userLogging } from "../../../utility/firestore";
import { useAppDispatch, useAppSelector } from "../../../app/hooks";
import { LOCAL_CONSTANT } from "../../Const";
import MessageDialog from "../../components/MessageDialog";
import {
    setSaveStatus,
    setOtherDocumentRRPath,
} from "../../../features/longPageSlice";
import { setOtherDocumentRRPdfPreview } from "../../../features/otherDocumentSlice";
import {
    deleteUploadFile,
    getFileMetadata,
    uploadFile,
} from "../../../utility/storage";
import PdfViewer from "../../../utility/PdfViewer";
import PdfViewerModal from "../../../utility/PdfViewerModal";
import { handlePdfPreviewScreenOpen } from "../../../utility/PdfViewerModal";
import { useUtilityContext } from "../../../utility-provider";
import {
    upsertLocationBaseFileParam,
    upsertLocationBaseDeleteFileParam,
    uploadRRFileJsonFunc,
    getOtherRRBucketPath,
    checkOtherRRDuplicateFile
} from "../../components/LocationBaseFunc";
import { useUserContext } from "../../../user-provider";
import { DeleteConfirmationModal } from "../../ResearchReport/DeleteConfirmationModal";
import { staffName, commonFileDownload, convertZenkakuToHankaku } from "../../Common";
import {locationBaseTypeList, initLocationBaseObj} from "../../../data/type";
import { BGDefaultColor, BGChangeColor } from "../../../data/table";

interface OtherDocumentRRProps {
    props: {};
}

const headerCell = (type: string) => {
    return {
        backgroundColor: "#D9D9D9",
        fontSize: "12px",
        color: "black",
        borderBottom: "1px solid black",
        fontWeight: "Bold",
        width:
            type === "MERGE_ORDER"
                ? "6%"
                : type === "FILE_NAME"
                ? "37%"
                : type === "UPLOAD_DATE"
                ? "15%"
                : type === "UPLOADER"
                ? "15%"
                : "6%",
        textAlign:
            type === "OTHER" || type === "MERGE_ORDER" ? "center" : "start",
    };
};

const OtherDocumentRR: React.FC<OtherDocumentRRProps> = ({ props }) => {

    //候補地NOと枝を取得
    const objLongPageParam = useAppSelector((state) => state.longPage.param);
    //調査書基本を取得
    const objLocationBase = useAppSelector((state) => state.longPage.locationBase);
    //調査書基本の項目値をReduxへ登録する前に保存
    const [locationBase, setLocationBase] = useState<locationBaseTypeList>(initLocationBaseObj);
    //パラメーターオブジェクト
    const objLongPageSaveStatus = useAppSelector((state) => state.longPage.saveStatus);
    const dispatch = useAppDispatch();

    const utilityCtx = useUtilityContext();

    //ファイルアップロード
    const [message, setMessage] = useState<string>("");
    const [messageDialogOpen, setMessageDialogOpen] = useState<boolean>(false);
    const [hasButton, setHasButton] = useState<boolean>(false);

    //ユーザーIDを取得
    const [userId, setUserId] = useState<string>("");
    //ユーザー種別を取得
    const [userType, setUserType] = useState<string>("");
    const user = useUserContext();

    //現在選択中のRRタイプを管理
    const [currentRRType, setCurrentRRType] = useState<string>("");

    //プレビュー
    const previewPdfPath = useAppSelector((state) => state.otherDocument.pdfPathRR);

    //モーダル開閉フラグ(削除確認)
    const [deleteConfModalOpen, setDeleteConfModalOpen] = useState(false);
    const [path, setPath] = useState<string>("");
    const [fileName, setFileName] = useState<string>("");
    const [date, setDate] = useState<string>("");

    //モーダル開閉フラグ(PDFプレビュー)
    const [pdfPreviewModalFlag, setPdfPreviewModalFlag] = useState(false);

    //全角入力フラグ
    const [zenkakuFlag, setZenkakuFlag] = useState(false);

    const handleDeleteConfModalOpen = (pathParam: string, nameParam: string, dateParam: string) => {
        setDeleteConfModalOpen(true);
        setPath(pathParam);
        setFileName(nameParam);
        setDate(dateParam);
    };

    //PDFプレビューモーダルオープン
    const handlePdfPreviewModalOpen = (pdfPathParam: string) => {
        setPdfPreviewModalFlag(true);
        setPath(pdfPathParam);
    };

    //プレビューを表示
    const handlePreviewChange = (pdfPath: string) => {
        const path = `gs://${process.env.REACT_APP_FIREBASE_STORAGE_BUCKET}/${objLongPageParam.planAreaId}/${objLongPageParam.branch}${pdfPath}`;
        if (previewPdfPath === path) {
            dispatch(setOtherDocumentRRPdfPreview(""));
        } else {
            dispatch(setOtherDocumentRRPdfPreview(path));
        }
    };

    const closeMessageDialog = () => {
        setMessage("");
        setHasButton(false);
        setMessageDialogOpen(false);
    };

    //ファイル保存
    const fileDownload = (path: string, fileName: string) => {
        const filePath = `/${objLongPageParam.planAreaId}/${objLongPageParam.branch}${path}`;
        commonFileDownload(filePath, fileName);
    };

    //ファイル削除
    const handlePdfDeleteChange = () => {
        // RRドキュメントの削除処理
        const newListUploadFileRR = objLocationBase.other_document_rr_path.filter((row) => row.path !== path);

        if (utilityCtx.showSpinner) {
            utilityCtx.showSpinner();
        }
        (async () => {
            try {
                setMessage(LOCAL_CONSTANT.CONFIRM_MESSAGE.DELETE_FILE);
                setMessageDialogOpen(true);
                //CloudStorageから削除対象のファイル情報を取得
                const deleteFile = await getFileMetadata(`/${objLongPageParam.planAreaId}/${objLongPageParam.branch}${path}`);
                await deleteUploadFile(deleteFile,`/${objLongPageParam.planAreaId}/${objLongPageParam.branch}${path}`);

                //RRドキュメントのDB保存
                const params = upsertLocationBaseDeleteFileParam(
                    objLocationBase,
                    objLongPageParam.planAreaId,
                    objLongPageParam.branch,
                    newListUploadFileRR,
                    "other_document_rr_path",
                    fileName
                );
                updateRegist(
                    params,
                    LOCAL_CONSTANT.FUNCTION_NAME.OTHER_PDF_RR_DELETE
                );
                //RRドキュメントのRedux保存
                dispatch(setOtherDocumentRRPath([...newListUploadFileRR]));

                //プレビューを戻す
                dispatch(setOtherDocumentRRPdfPreview(""));
                setMessage(LOCAL_CONSTANT.CONFIRM_MESSAGE.SUCCESS_DELETE_FILE);
                setHasButton(true);
                if (utilityCtx.hideSpinner) {
                    utilityCtx.hideSpinner();
                }
            } catch (e) {
                console.log(e);
                setMessage(LOCAL_CONSTANT.CONFIRM_MESSAGE.ERROR_DELETE_FILE);
                setHasButton(true);
                if (utilityCtx.hideSpinner) {
                    utilityCtx.hideSpinner();
                }
            }
        })();
    };

    const updateRegist = (params: any, function_name: string) => {
        userLogging(function_name, params, user);
        if (utilityCtx.showSpinner) {
            utilityCtx.showSpinner();
        }
        (async () => {
            try {
                await apiRequest(params);
                if (utilityCtx.hideSpinner) {
                    utilityCtx.hideSpinner();
                }
            } catch (e) {
                console.log(e);
                if (utilityCtx.hideSpinner) {
                    utilityCtx.hideSpinner();
                }
            }
        })();
    };

    // RRドキュメントの表示順序をソートする関数
    const sortRRDocuments = (documents: any[]) => {
        const typeOrder: { [key: string]: number } = {
            "01_color_mail": 1,
            "02_basis_sheet": 2,
            "99_other": 3,
        };

        return [...documents].sort((a, b) => {
            const orderA = typeOrder[a.other_rr_type];
            const orderB = typeOrder[b.other_rr_type];

            // other_rr_typeが同じ場合
            if (orderA === orderB) {
                // 99_otherの場合はupload_dateで昇順ソート
                if (a.other_rr_type === "99_other" && b.other_rr_type === "99_other") {
                    return new Date(a.upload_date).getTime() - new Date(b.upload_date).getTime();
                }
                return 0;
            }

            return orderA - orderB;
        });
    };

    // RRドキュメントアップロード処理
    const handleRRDocumentUpload = (rrType: string) => {
        setCurrentRRType(rrType);
        const fileElem = document.getElementById("rrDocumentFileElem");
        if (fileElem) {
            fileElem.click();
        }
    };

    // ファイル選択時の処理
    const handleChangeRRFile = (newFile: any) => {
        if (newFile.target.files[0] && currentRRType) {
            fileUploadRR(newFile.target.files[0], currentRRType);
        }
        newFile.target.value = "";
    };

    // 既存ファイル削除処理
    const deleteExistingFiles = async (existingFiles: any[]) => {
        for (const existingFile of existingFiles) {
            try {
                const existingFilePath = `${objLongPageParam.planAreaId}/${objLongPageParam.branch}${existingFile.path}`;
                const deleteFileMetadata = await getFileMetadata(existingFilePath);
                await deleteUploadFile(deleteFileMetadata, existingFilePath);
            } catch (deleteError) {
                console.log("既存ファイル削除エラー:", deleteError);
            }
        }
    };

    // 99_other同名ファイルチェック
    const checkDuplicateFile = (file: any): boolean => {
        if (!checkOtherRRDuplicateFile(file.name, objLocationBase.other_document_rr_path)) {
            setMessage(LOCAL_CONSTANT.CONFIRM_MESSAGE.DUPLICATE_FILE_ERROR);
            setHasButton(true);
            if (utilityCtx.hideSpinner) {
                utilityCtx.hideSpinner();
            }
            return false;
        }
        return true;
    };

    // ファイルアップロード処理
    const fileUploadRR = (file: any, rrType: string) => {
        if (utilityCtx.showSpinner) {
            utilityCtx.showSpinner();
        }
        (async () => {
            try {
                setMessage(LOCAL_CONSTANT.CONFIRM_MESSAGE.UPLOAD_FILE);
                setMessageDialogOpen(true);

                // 99_otherの場合、同名ファイルが既に存在するかチェック（存在する場合はアップロード中断）
                if (rrType === "99_other" && !checkDuplicateFile(file)) {
                    return;
                }

                // 既存ファイル削除（01_color_mail、02_basis_sheetの場合）
                if (rrType === "01_color_mail" || rrType === "02_basis_sheet") {
                    const existingFiles = objLocationBase.other_document_rr_path.filter((item: any) => item.other_rr_type === rrType);
                    if (existingFiles.length > 0) {
                        await deleteExistingFiles(existingFiles);
                    }
                }

                // ファイルアップロード
                const bucketPath = getOtherRRBucketPath(objLongPageParam.planAreaId, objLongPageParam.branch, rrType);
                const uploadFileName = file.name;
                await uploadFile(file, `${bucketPath}${uploadFileName}`);
                const uploadResultFile = await getFileMetadata(`${bucketPath}${uploadFileName}`);

                // RRドキュメント用のJSONデータ作成
                const newUploadFile = uploadRRFileJsonFunc(
                    uploadResultFile,
                    userId,
                    staffName(userId),
                    rrType
                );

                // ファイル配列の作成
                let updatedFiles;
                if (rrType === "99_other") {
                    updatedFiles = [...objLocationBase.other_document_rr_path, newUploadFile];
                } else {
                    const filteredFiles = objLocationBase.other_document_rr_path.filter((item: any) => item.other_rr_type !== rrType);
                    updatedFiles = [...filteredFiles, newUploadFile];
                }

                //DB保存
                const params = upsertLocationBaseFileParam(
                    objLocationBase,
                    objLongPageParam.planAreaId,
                    objLongPageParam.branch,
                    updatedFiles,
                    "other_document_rr_path",
                    uploadFileName
                );
                updateRegist(
                    params,
                    LOCAL_CONSTANT.FUNCTION_NAME.OTHER_PDF_RR_UPLOAD
                );

                //Redux保存
                dispatch(setOtherDocumentRRPath(updatedFiles));

                //更新フラグ
                dispatch(setSaveStatus({ ...objLongPageSaveStatus, LongPage: false }));

                setMessage(LOCAL_CONSTANT.CONFIRM_MESSAGE.SUCCESS_UPLOAD_FILE);
                setHasButton(true);
                if (utilityCtx.hideSpinner) {
                    utilityCtx.hideSpinner();
                }
            } catch (e) {
                console.log(e);
                setMessage(LOCAL_CONSTANT.CONFIRM_MESSAGE.ERROR_UPLOAD_FILE);
                setHasButton(true);
                if (utilityCtx.hideSpinner) {
                    utilityCtx.hideSpinner();
                }
            }
        })();
    };


    // テキストフィールド入力
    const handleMergeOrderChange = (data: any, value: string) => {
        // 先頭が全角ゼロ「０」または半角ゼロ「0」の場合は処理を中断
        if (value.startsWith("０") || value.startsWith("0")) {
            return;
        }

        // 全角数字が含まれているかチェック
        if (!zenkakuFlag && /[０-９]/.test(value)) {
            setZenkakuFlag(true);
        }

        // 全角・半角数字のみを許可（空文字も許可）
        if (value === "" || /^[１-９1-9][０-９0-9]*$/.test(value)) {
            const targetIndex = locationBase.other_document_rr_path.findIndex(
                file => file.path === data.path && file.other_rr_type === "99_other"
            );
            if (targetIndex !== -1) {
                const updatedFiles = [...locationBase.other_document_rr_path];
                updatedFiles[targetIndex] = { ...updatedFiles[targetIndex], merge_order: value };
                setLocationBase({...locationBase, other_document_rr_path: updatedFiles})
            }
        }
        // 更新フラグ
        if (!objLongPageSaveStatus.LongPage)
            dispatch(setSaveStatus({ ...objLongPageSaveStatus, LongPage: true }));
    };

    const handleMergeOrderBlur = () => {
        if (zenkakuFlag) {
            // 変換が必要なファイルのみを特定して処理
            const filesToConvert = locationBase.other_document_rr_path.filter(file => 
                file.other_rr_type === "99_other" && file.merge_order && /[０-９]/.test(file.merge_order)
            );
            
            if (filesToConvert.length > 0) {
                const convertedFiles = locationBase.other_document_rr_path.map(file => {
                    if (filesToConvert.some(f => f.path === file.path)) {
                        return {
                            ...file,
                            merge_order: convertZenkakuToHankaku(file.merge_order)
                        };
                    }
                    return file;
                });
                dispatch(setOtherDocumentRRPath(convertedFiles));
            } else {
                // 変換対象がない場合でもReduxに保存
                dispatch(setOtherDocumentRRPath(locationBase.other_document_rr_path));
            }
            setZenkakuFlag(false);
        } else {
            // 半角の場合もReduxに保存
            dispatch(setOtherDocumentRRPath(locationBase.other_document_rr_path));
        }
    };

    useEffect(() => {
        if (JSON.parse(user.userData || "null") !== null) {
            //ユーザーIDを取得
            setUserId(JSON.parse(user.userData || "null").staff_number);
            //ユーザー種別を取得
            setUserType(JSON.parse(user.userData || "null").user_type);
        }
    }, [user]);

    useEffect(() => {
        setLocationBase(objLocationBase);
    }, [objLocationBase.other_document_rr_path]);

    return (
        <Box>
            {userType === LOCAL_CONSTANT.USER_TYPE.RR && (
                <>
                    <Typography component="h2" sx={{ margin: "20px 0 5px 0" }}>その他資料RR用</Typography>
                    {/* RR用ボタンセクション */}
                    <Box sx={{ display: "flex", gap: 2, margin: "10px 0" }}>
                        <Button
                            variant="contained"
                            color="success"
                            size="small"
                            onClick={() => handleRRDocumentUpload("01_color_mail")}
                        >
                            白色⇒色紙承認メール
                        </Button>
                        <Button
                            variant="contained"
                            color="success"
                            size="small"
                            onClick={() => handleRRDocumentUpload("02_basis_sheet")}
                        >
                            車・人の共通比根拠シート
                        </Button>
                        <Button
                            variant="contained"
                            color="success"
                            size="small"
                            onClick={() => handleRRDocumentUpload("99_other")}
                        >
                            その他資料添付
                        </Button>
                    </Box>

                    <Typography sx={{ color: "red" }}>番号を入力しないと、調査書一式PDFに結合されません</Typography>

                    <Box sx={{ display: "flex" }}>
                        <MessageDialog
                            props={{
                                open: messageDialogOpen,
                                handleModal: closeMessageDialog,
                                body: message,
                                hasButton: hasButton,
                                buttonBody: LOCAL_CONSTANT.LABEL.CLOSE,
                            }}
                        />
                    </Box>

                    <Grid container spacing={1}>
                        <Grid item xs={12} sx={{ paddingRight: "40px" }}>
                            <TableContainer
                                sx={{
                                    height: "424px",
                                    width: "100%",
                                    border: "1px solid black",
                                }}
                            >
                                <Table stickyHeader>
                                    <TableHead>
                                        <TableRow>
                                            <TableCell sx={headerCell("MERGE_ORDER")}>結合順</TableCell>
                                            <TableCell sx={headerCell("FILE_NAME")}>{LOCAL_CONSTANT.LABEL.FILE_NAME}</TableCell>
                                            <TableCell sx={headerCell("UPLOAD_DATE")}>{LOCAL_CONSTANT.LABEL.UPLOAD_DATE}</TableCell>
                                            <TableCell sx={headerCell("UPLOADER")}>{LOCAL_CONSTANT.LABEL.UPLOADER}</TableCell>
                                            <TableCell sx={headerCell("OTHER")}></TableCell>
                                            <TableCell sx={headerCell("OTHER")}></TableCell>
                                            <TableCell sx={headerCell("OTHER")}></TableCell>
                                            <TableCell sx={headerCell("OTHER")}></TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {sortRRDocuments(locationBase.other_document_rr_path).map((data, index) => (
                                            <TableRow className="tableRow" key={index}>
                                                <TableCell
                                                    sx={{
                                                        textAlign: "center",
                                                        padding: 0,
                                                        height: "73px",
                                                    }}
                                                >
                                                    {data.other_rr_type === "99_other" && (
                                                        <TextField
                                                            value={data.merge_order}
                                                            onChange={(e) => handleMergeOrderChange(data, e.target.value)}
                                                            onBlur={() => handleMergeOrderBlur()}
                                                            sx={{
                                                                width: "100%",
                                                                height: "73px",
                                                                "& .MuiInputBase-root":
                                                                    {
                                                                        height: "73px",
                                                                        padding: 0,
                                                                        margin: 0,
                                                                    },
                                                                "& .MuiInputBase-input":
                                                                    {
                                                                        padding: 0,
                                                                        textAlign: "center",
                                                                        height: "73px",
                                                                        lineHeight: "73px",
                                                                        backgroundColor: data.merge_order ? BGChangeColor : BGDefaultColor,
                                                                    },
                                                            }}
                                                        />
                                                    )}
                                                </TableCell>
                                                <TableCell onClick={() => handlePreviewChange(data.path)}>{data.file_name}</TableCell>
                                                <TableCell onClick={() => handlePreviewChange(data.path)}>{data.upload_date}</TableCell>
                                                <TableCell onClick={() => handlePreviewChange(data.path)}>{data.upload_user_name}</TableCell>
                                                <TableCell sx={{ textAlign: "center" }}>
                                                    <IconButton
                                                        sx={{ color: "black" }}
                                                        onClick={() => handlePdfPreviewModalOpen(`/${objLongPageParam.planAreaId}/${objLongPageParam.branch}${data.path}`)}
                                                    >
                                                        <PictureAsPdfIcon />
                                                    </IconButton>
                                                </TableCell>
                                                <TableCell sx={{ textAlign: "center" }}>
                                                    <IconButton
                                                        sx={{ color: "black" }}
                                                        onClick={() => handlePdfPreviewScreenOpen(`/${objLongPageParam.planAreaId}/${objLongPageParam.branch}${data.path}`)}
                                                    >
                                                        <OpenInNewIcon />
                                                    </IconButton>
                                                </TableCell>
                                                <TableCell sx={{ textAlign: "center" }}>
                                                    <IconButton
                                                        sx={{ color: "black" }}
                                                        onClick={() => fileDownload(data.path, data.file_name)}
                                                    >
                                                        <DownloadIcon />
                                                    </IconButton>
                                                </TableCell>
                                                <TableCell sx={{ textAlign: "center" }}>
                                                    <IconButton
                                                        sx={{ color: "black" }}
                                                        onClick={() => handleDeleteConfModalOpen(data.path, data.file_name, data.upload_date)}
                                                    >
                                                        <DeleteIcon />
                                                    </IconButton>
                                                </TableCell>
                                            </TableRow>
                                        ))}
                                    </TableBody>
                                </Table>
                            </TableContainer>
                        </Grid>
                    </Grid>

                    {/* プレビュー */}
                    {previewPdfPath !== "" && (
                        <Box sx={{ padding: "30px 40px 0px 0px" }}>
                            <PdfViewer props={{ pdfPath: previewPdfPath }} />
                        </Box>
                    )}

                    {/* 削除確認モーダル */}
                    <DeleteConfirmationModal
                        modalOpen={deleteConfModalOpen}
                        setModalOpen={setDeleteConfModalOpen}
                        deleteMethod={handlePdfDeleteChange}
                    />

                    {/* PDFプレビューモーダル */}
                    <PdfViewerModal
                        props={{
                            open: pdfPreviewModalFlag,
                            setOpen: setPdfPreviewModalFlag,
                            pdfPath: path,
                        }}
                    />

                    {/* RRドキュメント用ファイル入力要素 */}
                    <input
                        id="rrDocumentFileElem"
                        type="file"
                        style={{ display: "none" }}
                        onChange={handleChangeRRFile}
                        accept=".pdf"
                    />
                </>
            )}
        </Box>
    );
};

export default OtherDocumentRR;
